import axios from "axios";

const hostname = window.location.hostname.toLowerCase();

// API base URL selection by host.
// Supports: ws{n}, site{n}, and worldshine{site_num}.mayo.llc.
const baseURL = hostname.includes("ws1") ||
  hostname.includes("site1") ||
  hostname.includes("localhost") ||
  hostname.includes("worldshine1.mayo.llc") ||
  hostname.includes("worldshine.mayo.llc")
  ? "https://ws1-tspt.mayosolution.com/api"
  : (hostname.includes("ws3") ||
      hostname.includes("site3") ||
      hostname.includes("worldshine3.mayo.llc") ||
      hostname.includes("worldshine3")
    )
      ? "https://ws3-tspt.mayosolution.com/api"
      : "https://ws2-tspt.mayosolution.com/api";

export default axios.create({
  baseURL,
  headers: {
    "Content-type": "application/json"
  }
});
